import React from 'react'
import { Alert } from '@ztechapps/webui.util'

export const Layout = () => {
  return (
    <Alert type="success">
      <h1>Welcome to the new Payme Admin Dashboard</h1>
      <small>
        It is an application skeleton for a typical web app. You can use it to quickly bootstrap your webapp projects
        and dev environment for these projects.
      </small>
    </Alert>
  )
}
